export const filtersMap = {
    age: 'id',
    brand: 'brand',
    color: 'code',
    dyncategory: 'id',
    gender: 'id',
    length: 'value',
    order: 'order',
    personalcategory: 'value',
    pricerange: 'pricerange',
    size: 'range',
    subcategory: 'id',
    tag: 'tag',
    topcat: 'id'
};

export const filterTrackingTypeMap = {
    age: 'age',
    brand: 'brand',
    color: 'color',
    dyncategory: 'dyncategory',
    gender: 'gender',
    length: 'length',
    personalcategory: 'personalcategory',
    pricerange: 'price',
    recently: 'recent',
    size: 'size',
    subcategory: 'subcategory',
    tag: 'tag',
    topcat: 'topcategory'
};
